<script lang="ts" setup>
/**
 * トークルーム追加表示ボタン。
 */

import { CommunityTalkStore, isValidCommunityTalkStoreKey } from "@/store/communityTalk/communityTalkStore";
import { defineProps, defineEmits, inject } from "vue";

interface Props {
	/**
	 * 「追加表示ボタン内部」文言。
	 */
	moreButtonDisplayName: string;
	/**
	 * APIから取得したトークルーム数。
	 */
	talkRoomCurrentDisplayCount: number;
	/**
	 * トークルーム総件数。
	 */
	talkRoomCount: number;
	/**
	 * トークルーム情報を追加している途中かどうか。
	 */
	isProcessingAddTalkRoom: boolean;

	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
}
const props = defineProps<Props>();

// Storeの初期化処理
if (!isValidCommunityTalkStoreKey(props.communityTalkStoreKey)) {
	// なんらかの原因でInjectKeyにエラーが発生していた場合は強制終了
	throw new Error(`InjectKeyにエラーが発生しました。${props.communityTalkStoreKey.toString()}`);
}
const communityTalkStore = inject(props.communityTalkStoreKey) as CommunityTalkStore;

/**
 * トークルームのもっと見るボタンを表示するかどうか。
 */
const isShow = (): boolean => {
	// トークルーム単体表示の場合は表示しない
	const displayTalkRoomId = communityTalkStore.getDisplayTalkRoomId();
	if (displayTalkRoomId != null && displayTalkRoomId !== "") {
		return false;
	}

	// APIから取得したトークルーム数がトークルーム総件数より少ない場合は表示する
	if (props.talkRoomCount > props.talkRoomCurrentDisplayCount) {
		return true;
	}

	return false;
};

interface Emits {
	(e: "click-more-button"): void;
}
const emit = defineEmits<Emits>();
const onclick = (): void => {
	emit("click-more-button");
};
</script>

<template>
	<!-- トークルームもっと見るボタン -->
	<div v-if="isShow()" class="revico-community-talk-talkroom-more-button-wrapper">
		<button type="button" class="revico-community-talk-talkroom-more-button" @click="onclick" :disabled="isProcessingAddTalkRoom">{{ moreButtonDisplayName }}</button>
	</div>
</template>

<style lang="scss">
.revico-widget .revico-community-talk .revico-community-talk {
	&-talkroom-more-button-wrapper {
		padding: 20px;
		text-align: center;
	}

	&-talkroom-more-button {
		@include resetButton;
		width: 60%;
		padding: 8px;
		color: white;
		background-color: var(--accent-color);
	}
}
</style>
